import type { StatePatch, TilesState, View3dState } from '../types.ts';

export const TILES_DEFAULT: TilesState = { show: false, highlight: true, opacity: 0.13 };
export const VIEW3D_DEFAULT: View3dState = { projection: 'persp', xray: false, cage: false, opacity: 1, mode: 'orbit' };

// Every control that a plate or a curve switch should own. Switching curve
// restores this baseline so a state dialled in for one curve never leaks
// silently into the next one.
export const BASE_STATE: Required<Omit<StatePatch, 'curve' | 'exportId' | 'stops' | 'plate'>> & { stops: string[] | null } = {
  preset: 'roygbiv',
  stops: null,          // null means take the preset's stops
  closure: 'mirror',
  rotation: 0,
  repeat: 1,
  reverse: false,
  hard: false,
  pingpong: true,
  autoCycles: false,
  colorMode: 'roygbiv',
  bgHex: '#ffffff',
  solidHex: '#000000',
  width: 1.2,
  aspect: 0,
  detail: 'auto',
};

// Per-curve departures from the baseline. Deliberately sparse.
const CURVE_STATE: Record<string, Partial<typeof BASE_STATE>> = {
  quaquacurve: { width: 0.8 },   // 3D, so overlapping strands read heavier
  quaquaversalcurve: { width: 0.8 },
};

export function defaultsFor(curveId: string): StatePatch {
  const d = { ...BASE_STATE, ...(CURVE_STATE[curveId] || {}) };
  const { stops, ...rest } = d;
  return stops ? { ...rest, stops } : rest;
}
